import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard24other from '../../partials/dashboard/DashboardCard24other';
function ReportotherPlanning() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto ">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 xs:pb-10 py-8 w-full max-w-9xl mx-auto">
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Raporteaza alte activitati</h1>
                            </div>
                        </div>
                        <div className='pb-14 sm:pb-0 md:pb-0 lg:pb-0'>
                            <DashboardCard24other />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default ReportotherPlanning;